import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var GetAgentsBundleInline;
(function (GetAgentsBundleInline) {
    GetAgentsBundleInline["ALL"] = "ALL";
    GetAgentsBundleInline["CHAT"] = "CHAT";
    GetAgentsBundleInline["REPORT"] = "REPORT";
})(GetAgentsBundleInline || (GetAgentsBundleInline = {}));
/** Get all Users text conversations */ export const getConversations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/conversations';
    const pathInternal = '/api/conversations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.before : (params.before ?? queryDefaults?.['before']);
        if (value !== undefined) {
            urlParams.append('before', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversations.paramsOrder = [{ type: 'parameters' }];
/** Create a new conversation */ export const createConversation = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/conversations';
    const pathInternal = '/api/conversations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createConversation.paramsOrder = [];
/** Get a specific conversation by ID */ export const getConversationById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversationById.paramsOrder = [{ type: 'parameters' }];
/** Updates a conversation title */ export const updateConversationTitle = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversationTitle.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Deactivate (archive) a conversation; nothing is deleted */ export const archiveConversation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
archiveConversation.paramsOrder = [{ type: 'parameters' }];
/** Set conversation active state */ export const setConversationActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-genai/conversations/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/conversations/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setConversationActive.paramsOrder = [{ type: 'parameters' }];
/** Clone a conversation. */ export const cloneConversation = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/conversations/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}/clone'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneConversation.paramsOrder = [{ type: 'parameters' }];
/** Get messages for a specific conversation */ export const getConversationMessages = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/conversations/{id}/messages'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}/messages'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.before : (params.before ?? queryDefaults?.['before']);
        if (value !== undefined) {
            urlParams.append('before', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversationMessages.paramsOrder = [{ type: 'parameters' }];
/** Add a new message to a conversation */ export const createMessage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.message === undefined) {
        throw new Error('Missing required body: message');
    }
    const path = '/api/ws-genai/conversations/{id}/messages'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/conversations/{id}/messages'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.message !== undefined) {
        body = params.message;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createMessage.paramsOrder = [{ type: 'body', paramName: 'message' }, { type: 'parameters' }];
/** Stop a streaming assistant message; the partial answer is kept */ export const stopMessage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.messageId === undefined) {
        throw new Error('Missing required parameter: messageId');
    }
    const path = '/api/ws-genai/conversations/{id}/messages/{messageId}/stop'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{messageId}', () => encodeURIComponent(String(params.messageId)));
    const pathInternal = '/api/conversations/{id}/messages/{messageId}/stop'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{messageId}', () => encodeURIComponent(String(params.messageId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
stopMessage.paramsOrder = [{ type: 'parameters' }];
/** Generate translations with AI */ export const generateTranslations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-genai/translations';
    const pathInternal = '/api/translations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateTranslations.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Generate the delivery summary paragraph for a campaign report email */ export const generateReportSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-genai/report-summaries';
    const pathInternal = '/api/report-summaries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateReportSummary.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Recommend AdWords-style keywords from website content and a campaign goal */ export const generateKeywordRecommendations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-genai/keyword-recommendations';
    const pathInternal = '/api/keyword-recommendations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateKeywordRecommendations.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Recommend a full targeting setup (keywords, negative keywords, IAB categories, sentiments, target contexts) from website content and an optional campaign context */ export const generateTargetingRecommendations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-genai/targeting-recommendations';
    const pathInternal = '/api/targeting-recommendations';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateTargetingRecommendations.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Classify one publisher from public signals (title, description, a few headlines) into an editorial tier, an editorial tone, weighted IAB topics, one audience archetype, a confidence rating and a short justification with sources. The caller owns every closed value list and passes it in; the answer is normalised against those lists, so an off-list tier, tone or archetype comes back empty and an invented IAB topic is dropped. No conversation and no agent is created. */ export const classifyPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-genai/publisher-classifications';
    const pathInternal = '/api/publisher-classifications';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
classifyPublisher.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get available LLM providers with their chat models */ export const getProviders = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/models/providers';
    const pathInternal = '/api/models/providers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getProviders.paramsOrder = [];
/** Whether the current user has already finished or skipped the first-run chat intro */ export const getIntroSeen = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/onboarding/intro-seen';
    const pathInternal = '/api/onboarding/intro-seen';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getIntroSeen.paramsOrder = [];
/** Mark the first-run chat intro as seen for the current user */ export const markIntroSeen = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/onboarding/intro-seen';
    const pathInternal = '/api/onboarding/intro-seen';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
markIntroSeen.paramsOrder = [];
/** Per-user chat usage (messages, tokens, estimated cost) for the caller's company, each user's usage also split per model */ export const getUsage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/usage';
    const pathInternal = '/api/usage';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.from : (params.from ?? queryDefaults?.['from']);
        if (value !== undefined) {
            urlParams.append('from', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.to : (params.to ?? queryDefaults?.['to']);
        if (value !== undefined) {
            urlParams.append('to', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUsage.paramsOrder = [{ type: 'parameters' }];
/** List agents in a category bundle (model + system prompt + MCP servers bundles); defaults to CHAT */ export const getAgents = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/agents';
    const pathInternal = '/api/agents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.bundle : (params.bundle ?? queryDefaults?.['bundle']);
        if (value !== undefined) {
            urlParams.append('bundle', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAgents.paramsOrder = [{ type: 'parameters' }];
/** Create a chat agent */ export const createAgent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.agentForm === undefined) {
        throw new Error('Missing required body: agentForm');
    }
    const path = '/api/ws-genai/agents';
    const pathInternal = '/api/agents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.agentForm !== undefined) {
        body = params.agentForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAgent.paramsOrder = [{ type: 'body', paramName: 'agentForm' }];
/** Update a chat agent */ export const updateAgent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.agentForm === undefined) {
        throw new Error('Missing required body: agentForm');
    }
    const path = '/api/ws-genai/agents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/agents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.agentForm !== undefined) {
        body = params.agentForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAgent.paramsOrder = [{ type: 'body', paramName: 'agentForm' }, { type: 'parameters' }];
/** Deactivate a chat agent (built-in agents cannot be deactivated); nothing is deleted */ export const deleteAgent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/agents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/agents/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteAgent.paramsOrder = [{ type: 'parameters' }];
/** Set chat agent active state (built-in agents cannot be deactivated) */ export const setAgentActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-genai/agents/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/agents/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setAgentActive.paramsOrder = [{ type: 'parameters' }];
/** List brand kits for document generation */ export const getBrandKits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/brand-kits';
    const pathInternal = '/api/brand-kits';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBrandKits.paramsOrder = [{ type: 'parameters' }];
/** Create a brand kit */ export const createBrandKit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.brandKitForm === undefined) {
        throw new Error('Missing required body: brandKitForm');
    }
    const path = '/api/ws-genai/brand-kits';
    const pathInternal = '/api/brand-kits';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.brandKitForm !== undefined) {
        body = params.brandKitForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createBrandKit.paramsOrder = [{ type: 'body', paramName: 'brandKitForm' }];
/** Extract brand colors and fonts from an uploaded PowerPoint template */ export const extractBrandKit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.brandKitExtractForm === undefined) {
        throw new Error('Missing required body: brandKitExtractForm');
    }
    const path = '/api/ws-genai/brand-kits/extract';
    const pathInternal = '/api/brand-kits/extract';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.brandKitExtractForm !== undefined) {
        body = params.brandKitExtractForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
extractBrandKit.paramsOrder = [{ type: 'body', paramName: 'brandKitExtractForm' }];
/** Update a brand kit */ export const updateBrandKit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.brandKitForm === undefined) {
        throw new Error('Missing required body: brandKitForm');
    }
    const path = '/api/ws-genai/brand-kits/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/brand-kits/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.brandKitForm !== undefined) {
        body = params.brandKitForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateBrandKit.paramsOrder = [{ type: 'body', paramName: 'brandKitForm' }, { type: 'parameters' }];
/** Deactivate a brand kit; nothing is deleted */ export const deleteBrandKit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/brand-kits/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/brand-kits/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteBrandKit.paramsOrder = [{ type: 'parameters' }];
/** Set brand kit active state */ export const setBrandKitActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-genai/brand-kits/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/brand-kits/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setBrandKitActive.paramsOrder = [{ type: 'parameters' }];
/** Get available MCP servers whose tools the chat can use */ export const getMcpServers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-genai/mcp-servers';
    const pathInternal = '/api/mcp-servers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMcpServers.paramsOrder = [{ type: 'parameters' }];
/** Add an MCP server */ export const createMcpServer = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.mcpServerForm === undefined) {
        throw new Error('Missing required body: mcpServerForm');
    }
    const path = '/api/ws-genai/mcp-servers';
    const pathInternal = '/api/mcp-servers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mcpServerForm !== undefined) {
        body = params.mcpServerForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createMcpServer.paramsOrder = [{ type: 'body', paramName: 'mcpServerForm' }];
/** Update an MCP server (built-in server URLs are configuration-managed) */ export const updateMcpServer = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.mcpServerForm === undefined) {
        throw new Error('Missing required body: mcpServerForm');
    }
    const path = '/api/ws-genai/mcp-servers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/mcp-servers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mcpServerForm !== undefined) {
        body = params.mcpServerForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateMcpServer.paramsOrder = [{ type: 'body', paramName: 'mcpServerForm' }, { type: 'parameters' }];
/** Deactivate an MCP server (built-in servers cannot be deactivated); nothing is deleted */ export const deleteMcpServer = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-genai/mcp-servers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/mcp-servers/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteMcpServer.paramsOrder = [{ type: 'parameters' }];
/** Set MCP server active state (built-in servers cannot be deactivated) */ export const setMcpServerActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-genai/mcp-servers/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    const pathInternal = '/api/mcp-servers/{id}/active/{active}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{active}', () => encodeURIComponent(String(params.active)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setMcpServerActive.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
